<template>
    <div class="RankBoardExplanatory">
        <el-popover
        placement="bottom"
        title=""
        :width="isDesktop ? 600 : 350"
        trigger="click">
            <ul style="padding-left: 20px; font-size: 11px;">
            <li class="top-margin-10">
                <b>Sorting - </b>
                Star sorting based on Annualise ROI in decile format.
            </li>
            <li class="top-margin-10">
                <b> Accuracy rate ( Sorting based on accuracy) -</b>
                Expert Accuracy rate weighted with number of results based accuracy and number of times recommendation updated to achieve accuracy.
            </li>
            <li class="top-margin-10">
                <b>Success Rate (Sorting based on success rate) - </b>
                Expert Success rate weighted with number of target achieved and number of times recommendation updated to achieve target price. 
            </li>
            <li class="top-margin-10">
                <b>Live reco (LR) -</b>
                Descending order.
            </li>
            <li class="top-margin-10">
                <b>Total reco (TR) -</b>
                Descending order. 
            </li>
            <li class="top-margin-10">
                <b>Sorting -</b>
                By default will be displayed for verified experts, manually user can compare selected experts.
            </li>
            <li class="top-margin-10">
                <b>User portfolio -</b>User contributed data is tracked and compared with own portfolio.
            </li>
            <li class="top-margin-10">
                <b>Green star -</b>
                Overall sorting based on My portfolio
            </li>
            <li class="top-margin-10">
                <b>Yellow star -</b>
                Overall sorting based on comparison with other experts on platform. 
            </li>
            <li class="top-margin-10">
                <b>Badge -</b>
                Social media sharable user profile which will change as per the metric selected e.g. ROI, Accuracy, Success rate, Live recommendation and Total recommendation 
            </li>
            <li class="top-margin-10">
                <b>Active expert -</b>
                Min 1 reco shared in past 3 months, Inactive user- reco not shared since last 3 months 
            </li>
            <li class="top-margin-10">
                Minimum 30 total recommendations and 1 live recommendation required for expert hub ranking and top experts rank board.
            </li>
            <li class="top-margin-10">
                Maximum 5 experts can be compared at at time on the dashboard and charts.
            </li>
            <li class="top-margin-10">Trending Stocks, Trending sector - based on searches.
            </li>
            
            </ul>
            <img class="info-Logo cursor-pointer top-margin-5"
            src="../assets/images/company/info-button.svg"
            style="height: 14px; margin-left: 15px;"
            slot="reference" />
        </el-popover>
    </div>
</template>
<script>
import { screenSize } from "../mixins/ScreenSize.js";

export default {
    name: 'RankBoardExplanatory',
    mixins: [screenSize],
}
</script>
